export const id = <T>(arg: T): T => arg;
export const noop = (): void => {};
